import { OverlayModule } from '@angular/cdk/overlay';
import { NgClass } from '@angular/common';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  inject,
  input,
} from '@angular/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'bo-tool-tip',
  templateUrl: './tool-tip.component.html',
  standalone: true,
  imports: [NgClass, OverlayModule, AngularSvgIconModule],
})
export class ToolTipComponent implements OnInit, OnDestroy {
  title = input<string>();
  text = input<string>();

  elementRef = inject(ElementRef);

  isOpen = false;

  onClickOutside(event: MouseEvent) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  ngOnInit() {
    document.addEventListener('click', this.onClickOutside.bind(this));
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.onClickOutside.bind(this));
  }
}
